import axios from 'axios'
let Base64 = require('js-base64').Base64;

axios.$http = {
    post(paras) {
        axios.post(paras.method, paras.params).then(function (resp) {
            if (resp.data.code == 0) {
                paras.success(resp.data.data);
            }
            else {
                paras.failure(resp.data.code, resp.data.msg);
            }
        }).catch(function (error) {
            if (paras.error != undefined) {
                paras.error(error);
            }
        });
    },
    get(paras) {
        //添加时间戳解决IE11下GET请求使用本地缓存问题
        axios.get(paras.method + "?" + Date.now(), {
            params: paras.params
        }).then(function (resp) {
            if (resp.data.code == 0) {
                paras.success(resp.data.data);
            }
            else if (resp.data.code == 401) {
                //window.location.href = "#/login?redirect_code=" + Base64.encode(window.location.href.split("#")[1]);
                window.location.href = "#/login";
                localStorage.removeItem("token");
                localStorage.removeItem("photourl");
            }
            else {
                paras.failure(resp.data.code, resp.data.msg);
            }
        }).catch(function (error) {
            if (paras.error != undefined) {
                paras.error(error);
            }
        });
    }
}

export default axios

